<div class="main-container">
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="header-container grad-purple"
  >
    <button
      mat-icon-button
      class="close-button"
      (click)="close()"
      aria-label="Close send Lineup Form panel"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <h3>Send {{ sendFormText }}</h3>
  </div>
  <div class="content-container">
    <ng-scrollbar [autoHeightDisabled]="false">
      <mat-stepper
        orientation="vertical"
        class="material-stepper"
        linear
        (selectionChange)="stepChanged($event)"
      >
        <mat-step [stepControl]="stepOneForm">
          <ng-template matStepLabel>
            <div fxLayout="column" fxLayoutGap="5px">
              <span class="title">Select {{ sendFormText }}</span>
            </div>
          </ng-template>
          <form [formGroup]="stepOneForm">
            <app-form-picker
              [form]="stepOneForm"
              controlName="applicationDefinition"
              [applications]="applicationDefinitions"
              placeholder="Select form"
              [required]="true"
              (formSelected)="onApplicationDefinitionSelectionChanged()"
            ></app-form-picker>
            @if (selectedApplicationDefinition) {
              <div>
                @if (selectedApplicationDefinition?.deadline) {
                  <p>
                    This form closes on
                    {{
                      selectedApplicationDefinition.deadline
                        | date: 'mediumDate'
                    }}.
                  </p>
                }
                @if (!selectedApplicationDefinition?.deadline) {
                  <p>This Lineup Form has no deadline.</p>
                }
                <button
                  mat-button
                  color="primary"
                  class="preview-application"
                  (click)="previewApplication()"
                >
                  PREVIEW FORM
                </button>
              </div>
            }
          </form>
          <div class="step-buttons" fxLayout fxLayoutGap="10px">
            <button
              mat-flat-button
              color="primary"
              matStepperNext
              [disabled]="!isStepOneValid"
            >
              Next
            </button>
          </div>
        </mat-step>
        @if (isSendingToSearchResult) {
          <mat-step [stepControl]="stepTwoForm">
            <ng-template matStepLabel>
              <div fxLayout="column" fxLayoutGap="5px">
                <span class="title">Recipients</span>
              </div>
            </ng-template>
            @if (isStepTwoLoading) {
              <mat-spinner diameter="50"></mat-spinner>
            } @else {
              @if (!isStepTwoLoading) {
                <form [formGroup]="stepTwoForm">
                  <div>
                    <mat-checkbox
                      color="primary"
                      [checked]="sendNew && sendReminder"
                      (change)="sendAllChanged($event)"
                      formControlName="sendAll"
                    >
                      <b
                        >Send to all
                        {{
                          potentialRecipientsCount
                            | i18nPlural
                              : { '=1': '1 person', other: '# people' }
                        }}</b
                      >
                    </mat-checkbox>
                  </div>
                  <div>
                    @if (resendRecipientsCount > 0) {
                      <mat-checkbox
                        color="primary"
                        formControlName="sendReminder"
                        (change)="sendReminderOrNewChanged($event)"
                        >Resend to
                        <b>{{
                          resendRecipientsCount
                            | i18nPlural
                              : { '=1': '1 person', other: '# people' }
                        }}</b>
                        who
                        {{
                          resendRecipientsCount
                            | i18nPlural: { '=1': 'has', other: 'have' }
                        }}
                        not yet completed this form</mat-checkbox
                      >
                    }
                  </div>
                  <div>
                    @if (newRecipientsCount > 0) {
                      <mat-checkbox
                        color="primary"
                        formControlName="sendNew"
                        (change)="sendReminderOrNewChanged($event)"
                        >Send to
                        <b>{{
                          newRecipientsCount
                            | i18nPlural
                              : { '=1': '1 person', other: '# people' }
                        }}</b>
                        who
                        {{
                          newRecipientsCount
                            | i18nPlural: { '=1': 'has', other: 'have' }
                        }}
                        never received this form</mat-checkbox
                      >
                    }
                  </div>
                  <div>
                    @if (hasTooManyRecipientsError) {
                      <mat-error>
                        You have selected too many people. We can only deliver
                        {{ maxRecipients }} emails at a time.
                      </mat-error>
                    }
                    @if (hasNoRecipientsError) {
                      <mat-error>
                        You must select at least one person.
                      </mat-error>
                    }
                  </div>
                </form>
              }
              <div class="step-buttons" fxLayout fxLayoutGap="10px">
                <button
                  mat-flat-button
                  color="primary"
                  matStepperNext
                  [disabled]="!isStepTwoValid"
                >
                  Next
                </button>
                <button
                  mat-stroked-button
                  matStepperPrevious
                  class="back-button"
                >
                  Back
                </button>
              </div>
            }
          </mat-step>
        }
        <mat-step>
          <ng-template matStepLabel>
            <div fxLayout="column" fxLayoutGap="5px">
              <span class="title">Finalize and send</span>
            </div>
          </ng-template>
          @if (isSendingToSearchResult) {
            <p>
              An email will be delivered to
              <b>{{
                recipientsCount
                  | i18nPlural: { '=1': '1 person', other: '# people' }
              }}</b>
              with a link to the {{ selectedApplicationDefinition?.title }}.
            </p>
          }
          @if (!isSendingToSearchResult) {
            <p>
              {{ person?.fullName }} ({{ person?.email }}) will receive a link
              to the {{ selectedApplicationDefinition?.title }}.
            </p>
          }
          <div class="step-buttons" fxLayout fxLayoutGap="10px">
            <button
              mat-flat-button
              color="primary"
              matStepperNext
              [disabled]="!isStepThreeValid"
              (click)="onSendClicked()"
            >
              Send Email Now
            </button>
            <button mat-stroked-button matStepperPrevious class="back-button">
              Back
            </button>
          </div>
        </mat-step>
      </mat-stepper>
    </ng-scrollbar>
  </div>
</div>
